export default __webpack_public_path__ + "static/media/wordle.5cec691f.png";